import { useGetProjectsQuery } from "../../features/projects/projectsApi";
import Project from "./Project";

export default function ProjectList() {
  const { data: projects, isLoading, isError } = useGetProjectsQuery();

  // decide what to render
  let content = null;

  if (isLoading) content = <h1>Loading</h1>;

  if (!isLoading && isError) content = <h1>There was an error</h1>;

  if (!isLoading && !isError && projects?.length === 0)
    content = <h1>No Team Member found!</h1>;

  if (!isLoading && !isError && projects?.length > 0)
    content = projects.map((project) => (
      <Project key={project.id} project={project} />
    ));
  return (
    <div>
      <h3 className="text-xl font-bold">Projects</h3>
      <div className="mt-3 space-y-4">{content}</div>
    </div>
  );
}
